import { DISMISS_BANNER } from '../redux/dismissableBanner';

import type {
  EventTracking,
  DismissBannerAction,
  DismissBannerTracker,
} from '../types';

function dismissBanner(action: DismissBannerAction): DismissBannerTracker {
  return {
    bannerId: action.payload.bannerId,
  };
}

const tracking: EventTracking = {};
tracking[DISMISS_BANNER] = dismissBanner;

export default tracking;
